class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('.tab-button'));
    this.tabPanels = this.querySelectorAll('.tab-panel');
    this.selectedIndex = 0;

    this.init();
  }

  init() {
    // Set initial ARIA attributes
    this.tabButtons.forEach((button, index) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', button.dataset.tab);
      button.setAttribute('tabindex', index === 0 ? '0' : '-1');

      // Click event
      button.addEventListener('click', () => this.switchTab(button.dataset.tab));

      // Keyboard events
      button.addEventListener('keydown', (e) => this.handleKeydown(e));
    });

    // Set initial ARIA attributes for panels
    this.tabPanels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', panel.dataset.panel);
    });
  }

  handleKeydown(event) {
    let targetIndex = this.selectedIndex;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        targetIndex = this.selectedIndex - 1;
        if (targetIndex < 0) targetIndex = this.tabButtons.length - 1;
        event.preventDefault();
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        targetIndex = this.selectedIndex + 1;
        if (targetIndex >= this.tabButtons.length) targetIndex = 0;
        event.preventDefault();
        break;
      case 'Home':
        targetIndex = 0;
        event.preventDefault();
        break;
      case 'End':
        targetIndex = this.tabButtons.length - 1;
        event.preventDefault();
        break;
      case 'Enter':
      case ' ':
        this.switchTab(event.target.dataset.tab);
        event.preventDefault();
        return;
      default:
        return;
    }

    // Update selected tab
    const targetTab = this.tabButtons[targetIndex].dataset.tab;
    this.switchTab(targetTab);
    this.tabButtons[targetIndex].focus();
  }

  switchTab(targetTab) {
    this.tabButtons.forEach((button, index) => {
      const isSelected = button.dataset.tab === targetTab;

      // Update selected index
      if (isSelected) {
        this.selectedIndex = index;
      }

      // Update ARIA and visual states
      button.setAttribute('aria-selected', isSelected);
      button.setAttribute('tabindex', isSelected ? '0' : '-1');
      button.classList.toggle('text-black', isSelected);
      button.classList.toggle('text-[#999999]', !isSelected);
      button.classList.toggle('hover:text-black', !isSelected);
    });

    this.tabPanels.forEach(panel => {
      const isVisible = panel.dataset.panel === targetTab;
      panel.classList.toggle('hidden', !isVisible);
      panel.setAttribute('aria-hidden', !isVisible);
    });
  }
}

customElements.define('product-tabs', ProductTabs);
